import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 50,
			height: 50,
			rx: 14,
			fill: "#DFF1FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 21.25L25 12.5L36.25 21.25V35C36.25 35.663 35.9866 36.2989 35.5178 36.7678C35.0489 37.2366 34.413 37.5 33.75 37.5H16.25C15.587 37.5 14.9511 37.2366 14.4822 36.7678C14.0134 36.2989 13.75 35.663 13.75 35V21.25Z",
			stroke: "#19243E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.25 37.5V25H28.75V37.5",
			stroke: "#19243E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHome;
